<template>
  <div class="h-100">
    <div class="map h-100" ref="map"></div>
  </div>
</template>

<script>
import 'leaflet/dist/leaflet.css';

import L from 'leaflet';
import 'leaflet.heat';
import { mapBoxKey } from '@/assets/keys';

// eslint-disable-next-line
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  // eslint-disable-next-line
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  // eslint-disable-next-line
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  // eslint-disable-next-line
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  name: 'ufo-map',
  props: ['value', 'ufos'],
  data() {
    const options = { tileSize: 512, maxZoom: 18, zoomOffset: -1 };
    return {
      zoom: 4,
      center: [50.465841, 4.857634],
      pH: 3,
      basemaps: {
        dark: L.tileLayer(
          `https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}@2x?access_token=${mapBoxKey}`,
          {
            attribution: `&copy; <a href="https://www.mapbox.com/feedback/">Mapbox</a>
                        &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>`,
            ...options,
          },
        ),
        light: L.tileLayer(
          `https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/{z}/{x}/{y}@2x?access_token=${mapBoxKey}`,
          {
            attribution: `&copy; <a href="https://www.mapbox.com/feedback/">Mapbox</a>
                        &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>`,
            ...options,
          },
        ),
        satellite: L.tileLayer(
          `https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}@2x?access_token=${mapBoxKey}`,
          {
            attribution: `&copy; <a href="https://www.mapbox.com/feedback/">Mapbox</a>
                        &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>`,
            ...options,
          },
        ),
      },
      circleDefaultStyle: {
        color: '#3388FF',
        radius: 5,
        weight: 3,
        opacity: 0.7,
      },
      circleHoveredStyle: {
        opacity: 1.0,
        color: 'red',
      },
      marker: L.latLng(50.465841, 4.857634),
      featureGroup: L.featureGroup(),
      featureGroupHovered: L.featureGroup(),
      map: null,
      intervalleHeuresPourTrajectoire: 8,
    };
  },
  mounted() {
    this.map = L.map(this.$refs.map, {
      center: this.center,
      zoom: this.zoom,
    });
    this.basemaps.dark.addTo(this.map);
    L.control.layers(this.basemaps).addTo(this.map);
    L.marker(this.center).addTo(this.map).bindPopup('Hello Namur');
    this.soucoupe();
    this.soupeAuxChoux();
    this.featureGroup.addTo(this.map);
    this.featureGroupHovered.addTo(this.map);
    this.updateLayers();
  },
  watch: {
    ufos() {
      this.updateLayers();
    },
  },
  methods: {
    updateLayers() {
      this.featureGroup.clearLayers();
      const geoJson = L.geoJson(this.ufos, {
        pointToLayer: (feature, latlng) => L.circleMarker(latlng, this.circleDefaultStyle),
        onEachFeature: (feature, layer) => {
          layer.on('click', () => {
            const popupHTML = document.createElement('div');
            popupHTML.innerHTML = `
              <p>${feature.properties.datetime}</p>
              <ul>
                <li>City: ${feature.properties.city}</li>
                <li>Country: ${feature.properties.admin}</li>
                <li>Duration: ${Math.round(feature.properties.duration_seconds / 6) / 10} min.</li>
                <li>Shape: ${feature.properties.shape}</li>
              </ul>
              <blockquote>&ldquo;${feature.properties.comments}&rdquo;</blockquote>
              <div class="text-center">
              <a href="https://maps.google.com/maps?layer=c&cbll=${feature.geometry.coordinates[1]},${feature.geometry.coordinates[0]}" target="_blank">
                <img width="300" height="120"
                  src="https://maps.googleapis.com/maps/api/streetview?size=300x120&fov=120&pitch=15&location=${feature.geometry.coordinates[1]},${feature.geometry.coordinates[0]}&key=AIzaSyB5mqiMLzE3VqmEMqU3zjPioJ41lJLNEGE">
              </a>
              <button class="my-button">Click</button>
              </div>`;
            const button = popupHTML.querySelector('.my-button');
            button.addEventListener('Utile?', () => this.clicked(feature.properties.datetime));
            layer.bindPopup(popupHTML);
            layer.openPopup();
          });
          layer.on('mouseover', e => this.showHovered(feature, e));
          layer.on('mouseout', (e) => {
            e.target.setStyle(this.circleDefaultStyle);
            this.featureGroupHovered.clearLayers();
          });
        },
      });
      this.featureGroup.addLayer(geoJson);
    },
    soucoupe() {
      L.circleMarker([45.562077, -0.325125], {
        color: 'darkorange',
        opacity: 0.2,
        radius: 1,
        fill: 'darkorange',
      }).addTo(this.map).bindPopup(`
        <p>On a retrouvé le héros de « La soucoupe et le perroquet »<br />
          <a href="https://www.nova.fr/retrouve-le-heros-de-la-soucoupe-et-le-perroquet-12" target="_blank">Lien 1</a>
          <a href="https://jeanclaude-suzanne.blogspot.com/" target="_blank">Lien 2</a>
        </p>
        <iframe width="300" height="169" src="https://www.youtube-nocookie.com/embed/SHJ1HL4eMLQ?rel=0&amp;start=509" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      `);
    },
    soupeAuxChoux() {
      L.circleMarker([48.666431, 2.657687], {
        color: 'darkorange',
        opacity: 0.2,
        radius: 1,
        fill: 'darkorange',
      }).addTo(this.map).bindPopup(`
        <p>Hameau fictif des Gourdiflots, lieu de tournage de «La soupe au choux»<br />
          <a href="https://fr.wikipedia.org/wiki/La_Soupe_aux_choux_(film)" target="_blank">sur Wikipedia</a>
        </p>
        <img src="http://fr.web.img2.acsta.net/medias/nmedia/18/36/11/21/18478117.jpg" width="300" frameborder="0" ></img>
      `);
    },
    clicked(msg) {
      // eslint-disable-next-line
      alert(msg);
    },
    showHovered(feature, e) {
      e.target.setStyle(this.circleHoveredStyle);
      const geoJson2 = this.ufos.filter((feature2) => {
        const dt = feature.properties.dateLuxon;
        const dt2 = feature2.properties.dateLuxon;
        const condition = dt2 >= dt.minus({ hours: this.pH })
          && dt2 <= dt.plus({ hours: this.pH });

        return condition;
      });

      const lLign = {
        type: 'Feature',
        properties: { datetime: geoJson2.map(pt => pt.properties.datetime) },
        geometry: { type: 'LineString', coordinates: geoJson2.map(pt => pt.geometry.coordinates) },
      };

      this.featureGroupHovered.addLayer(L.geoJson(geoJson2.filter(f => f !== feature), {
        pointToLayer: (feature3, latlng3) => L.circleMarker(latlng3, this.circleHoveredStyle),
      }));
      // ca marche ?
      this.featureGroupHovered.addLayer(L.geoJson(lLign, { color: 'yellow' }));
      //
    },
  },
};
</script>

<style scoped>
  .map {
    min-height: 500px;
  }

  .leaflet-container {
    background-color: black;
  }
  .leaflet-container >>> .leaflet-popup-content-wrapper {
    background-color: lightgreen;
    font-family: 'IBM Plex Mono', 'Courier New', Courier, monospace;
  }
  .leaflet-container >>> .leaflet-popup-tip {
    background-color: lightgreen;
  }
</style>
